import { Link } from "react-router-dom";
import { assets, FEATURED_EVENT_SLUG } from "../data.ts";
import { ImageSlot } from "./ImageSlot.tsx";
import { Reveal } from "./Reveal.tsx";

export function FeaturedEvents() {
  return (
    <section id="featured" aria-label="Featured Events" className="bg-cream pb-20 pt-20 text-[#141210] md:pb-28 md:pt-28 lg:pb-[130px] lg:pt-[120px]">
      <div className="mx-auto max-w-shell px-5 md:px-8 lg:px-12">
        <Reveal className="mb-[54px] flex flex-wrap items-end justify-between gap-6">
          <div>
            <div className="mb-5 font-mono text-xs uppercase tracking-[.28em] text-flame">Featured</div>
            <h2 className="m-0 font-archivo text-[clamp(36px,4.4vw,62px)] font-extrabold leading-[1] tracking-[-.03em]">
              This season's
              <br />
              headline gatherings.
            </h2>
          </div>
        </Reveal>

        {/* HERO FEATURE */}
        <Reveal className="mb-[30px] grid grid-cols-1 overflow-hidden rounded-[6px] border border-[#e6e1d8] bg-white shadow-[0_30px_60px_-40px_rgba(20,18,16,.4)] lg:grid-cols-[1.5fr_1fr]">
          <div className="relative min-h-[480px] overflow-hidden">
            <ImageSlot
              src={assets.eyekandy}
              alt="EyeKandy Kustoms shop floor with fresh builds"
              parallax={0.04}
              className="absolute inset-x-0 -top-[6%] h-[112%] w-full"
            />
            <div className="absolute left-[22px] top-[22px] flex gap-2">
              <span className="rounded-[7px] bg-flame px-3 py-[7px] font-mono text-[11px] font-medium uppercase tracking-[.12em] text-white">
                Featured
              </span>
              <span className="rounded-[7px] bg-[rgba(12,11,10,.6)] px-3 py-[7px] font-mono text-[11px] uppercase tracking-[.12em] text-white backdrop-blur-[8px]">
                Land
              </span>
            </div>
          </div>
          <div className="flex flex-col justify-center px-6 py-8 md:px-11 md:py-12">
            <div className="mb-4 font-mono text-[13px] font-medium tracking-[.1em] text-flame">
              Canada Day · July 1, 2026
            </div>
            <h3 className="m-0 mb-3.5 font-archivo text-[clamp(30px,3vw,46px)] font-extrabold leading-[1.04] tracking-[-.025em]">
              EyeKandy Kustoms Open House
            </h3>
            <div className="mb-[22px] text-[15px] text-[#76706a]">
              Hosted by <strong className="font-bold text-[#141210]">EyeKandy Kustoms</strong> · Vancouver, BC
            </div>
            <p className="m-0 mb-[30px] text-[16.5px] leading-[1.6] text-[#46413c]">
              A full-throttle Canada Day shop takeover — fresh builds rolled out, the paint booth open, food trucks in
              the lot, and the West Coast custom scene under one roof.
            </p>
            <div className="mb-8 flex flex-wrap gap-[26px]">
              <MetaItem label="Where" value="Vancouver, BC" />
              <MetaItem label="Entry" value="Free · All ages" />
              <MetaItem label="Category" value="Custom · Restoration" />
            </div>
            <div className="flex flex-wrap gap-3">
              <Link
                to={`/${FEATURED_EVENT_SLUG}`}
                className="inline-flex items-center gap-2.5 rounded-[11px] border border-flame bg-flame px-[26px] py-3.5 text-[15px] font-bold text-white no-underline transition hover:border-flame-dark hover:bg-flame-dark"
              >
                View Event
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

function MetaItem({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <div className="mb-[5px] font-mono text-[10.5px] uppercase tracking-[.14em] text-[#9a948c]">{label}</div>
      <div className="text-[14.5px] font-semibold">{value}</div>
    </div>
  );
}
